import React from 'react';
import PropTypes from 'prop-types';
import Flag from 'components/Flag';
import COUNTRIES from 'assets/data/countries';
import { MdClear } from 'react-icons/md';
import { ChipContainer } from './styled';

const Chip = ({ countryCode, onDelete, icon, text, className }) => {
  if (countryCode) {
    const country = COUNTRIES.find((c) => c.code === countryCode);

    return (
      <ChipContainer className={className} readOnly={!onDelete}>
        <Flag code={countryCode} />
        {country?.name || ''}
        {onDelete && <MdClear onClick={onDelete} />}
      </ChipContainer>
    );
  }

  return (
    <ChipContainer className={className} readOnly={!onDelete}>
      {icon}
      {text}
      {onDelete && <MdClear onClick={onDelete} />}
    </ChipContainer>
  );
};

Chip.propTypes = {
  countryCode: PropTypes.string,
  onDelete: PropTypes.func,
  className: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.node
};

export default Chip;
